import React, { useEffect } from 'react';
import {
    Container,
    Row,
    Col,
    Button,
    FieldsetControl,
    RadioControl,
    InputControl,
    SegmentLoader,
    ButtonGroup,
    ButtonLink,
} from '@si-armes/dsfr-react';
import { useForm, FormProvider } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { TYPE_TRANSFERT_PRET } from '../../../../utils/TransfertArmesConstant';
import { postAPI, reinitialiseAPI } from '../../../../store/apiReducer';
import {
    API_TRANSFERT_PRET,
    CONTEXT_TRANSFERT_PRET,
} from '../../../../constants/apiUrls.constants';
import usagerClientReducer from '../../../../store/usagerReducer';
import RoutesRatelier from '../../ratelier/routes';
import { getPath } from '../../../../utils/router';

const TransfertPourPret = () => {
    const { isLoading: isLoadingTransfertPret, data: dataTransfertPret } = useSelector(
        (state) => state.transferts.transfertPretStore,
    );

    const { uuidArme } = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
    const methods = useForm({
        mode: 'onChange',
        defaultValues: {
            arme: uuidArme,
            typeTransaction: TYPE_TRANSFERT_PRET.toString(),
            numeroSiaDestinataire: '',
            modaliteTransaction: null,
        },
    });

    const { handleSubmit, register, formState } = methods;
    const { isValid } = formState;

    const onSubmit = async (data) => {
        dispatch(postAPI(usagerClientReducer, API_TRANSFERT_PRET, data, CONTEXT_TRANSFERT_PRET));
    };

    useEffect(() => {
        if (dataTransfertPret) {
            const handleRedirect = async () => {
                await dispatch(reinitialiseAPI(CONTEXT_TRANSFERT_PRET));

                history.push(getPath(RoutesRatelier));
            };

            handleRedirect();
        }
    }, [dataTransfertPret]);

    return (
        <SegmentLoader isLoading={isLoadingTransfertPret}>
            <Container fluid={false}>
                <Row>
                    <Col col={12}>
                        <h1>Transfert</h1>
                    </Col>
                </Row>

                <FormProvider {...methods}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Row className="margin-top-md">
                            <Col col={12}>
                                <h4>Type de transfert</h4>
                                <FieldsetControl>
                                    <RadioControl
                                        id="transfert-pret"
                                        label="Transfert pour prêt"
                                        value={TYPE_TRANSFERT_PRET}
                                        {...register('typeTransaction', { required: true })}
                                    />
                                </FieldsetControl>
                            </Col>
                        </Row>

                        <Row className="margin-top-md">
                            <Col col={12} lg={6}>
                                <h4>Destination</h4>
                                <InputControl
                                    id="numero-sia"
                                    label="Numéro SIA du destinataire *"
                                    uppercase
                                    {...register('numeroSiaDestinataire', { required: true })}
                                />
                            </Col>
                        </Row>

                        <Row className="margin-top-md">
                            <Col col={12}>
                                <h4>Modalités de transfert</h4>
                                <FieldsetControl inline>
                                    <RadioControl
                                        id="envoi-arme"
                                        label="Envoi de l'arme"
                                        value="1"
                                        {...register('modaliteTransaction', { required: true })}
                                    />
                                    <RadioControl
                                        id="remise-main-propre"
                                        label="Remise en mains propres"
                                        value="2"
                                        {...register('modaliteTransaction', { required: true })}
                                    />
                                </FieldsetControl>
                            </Col>
                        </Row>

                        <Row className="margin-top-lg">
                            <Col col={12} className="text-right">
                                <ButtonGroup align="right" inline>
                                    <ButtonLink
                                        as={Link}
                                        to={getPath(RoutesRatelier)}
                                        variant="secondary"
                                        aria-label="Annuler"
                                    >
                                        Annuler
                                    </ButtonLink>
                                    <Button
                                        align="right"
                                        variant="primary"
                                        type="submit"
                                        disabled={!isValid}
                                    >
                                        Valider
                                    </Button>
                                </ButtonGroup>
                            </Col>
                        </Row>
                    </form>
                </FormProvider>
            </Container>
        </SegmentLoader>
    );
};

export default TransfertPourPret;
